import { createContext, useEffect, useState } from "react";
// Create the CampaignSetupContext
const CampaignSetupContext = createContext({
  campaignState: {},
  b2b2cCampaignEnabled: false,
  setB2b2cCampaignEnabled: () => null,
  toastData: [],
  stepper: 0,
  setToastData: () => null,
  stepsForCampaignSetup: [],
  currentCampaignTypeConfig: {},
  setCampaignState: () => null,
  setCurrentCampaignTypeConfig: () => null,
  setStepsForCampaignSetup: () => null,
  resetCurrentCampaignTypeConfig: () => null,
  resetCampaignState: () => null,
  originalCampaignDates: null,
  setOriginalCampaignDates: () => null,
});

// Create the CampaignSetupProvider component
const CampaignSetupProvider = ({ children }) => {
  // Define the initial state
  const initialState = {
    type: "",
    id: "",
    activities: [],
    outcomes: [],
    campaignRules: [],
    segments: [],
    excludeSegments: [],
    campaignContent: null,
    relatedContents: [],
  };

  const [campaignState, setCampaignState] = useState(initialState);
  const [b2b2cCampaignEnabled, setB2b2cCampaignEnabled] = useState(false);
  const [currentCampaignTypeConfig, setCurrentCampaignTypeConfig] = useState({});
  const [toastData, setToastData] = useState([]);
  const [stepsForCampaignSetup, setStepsForCampaignSetup] = useState([]);
  const [stepper, setStepper] = useState(0);
  // Snapshot of the dates as originally loaded from the server, used to detect edits to an existing campaign's dates
  const [originalCampaignDates, setOriginalCampaignDates] = useState(null);

  useEffect(() => {
    if (
      currentCampaignTypeConfig &&
      currentCampaignTypeConfig.steps &&
      currentCampaignTypeConfig.steps.length
    ) {
      setStepsForCampaignSetup(
        currentCampaignTypeConfig.steps.map((step) => ({
          ...step,
          label: step.label,
          url: step.slug,
          disableNext: false /* TODO: update it to true. once valdations are done */,
        }))
      );
    }
  }, [currentCampaignTypeConfig, currentCampaignTypeConfig.key]);
  const resetCampaignState = () => {
    setCampaignState(initialState);
    setB2b2cCampaignEnabled(false);
    setOriginalCampaignDates(null);
  };

  const resetCurrentCampaignTypeConfig = () => {
    setCurrentCampaignTypeConfig({});
  };

  // Create the context value
  const contextValue = {
    toastData,
    setToastData,
    campaignState,
    b2b2cCampaignEnabled,
    setB2b2cCampaignEnabled,
    stepper,
    setStepper,
    stepsForCampaignSetup,
    currentCampaignTypeConfig,
    setCurrentCampaignTypeConfig,
    setStepsForCampaignSetup,
    resetCurrentCampaignTypeConfig,
    resetCampaignState,
    setCampaignState,
    originalCampaignDates,
    setOriginalCampaignDates,
    // Add any functions or methods to update the state here
  };

  // Render the provider with the context value and children
  return (
    <CampaignSetupContext.Provider value={contextValue}>
      {children}
    </CampaignSetupContext.Provider>
  );
};

export { CampaignSetupContext, CampaignSetupProvider };
